<div #container>
  <app-portada-fichas *ngIf="datos" [posgrado]="true" [viewVenue]="true" [viewArea]="true" [viewNivel]="true"
    [paddingRight]="'13vw'" [paddingLeft]="'10vw'" [datos]="datos" [carrer]="carrer" [venue]="venue"
    [region]="datos.region" [svgContent]="svgContent"></app-portada-fichas>


  <section id="section-primary" *ngIf="datos">
    <div class="contenedores-seccion no-margin">
      <app-aranceles-posgrado [datos]="datos"></app-aranceles-posgrado>
    </div>
  </section>
  <section *ngIf="imagesSlider.length > 0">
    <app-slider [images]="imagesSlider"></app-slider>
  </section>
  <section *ngIf="datos">
    <div class="contenedores-seccion">
      <app-plan-de-estudio-posgrado [planData]="datos.studyPlanItems" [methodPay]="datos.general_data_obj?.metodos_pago"
        [workload]="datos.workload" [titlesPlanData]="datos.studyPlan[0]" [accreditation]="datos.accreditation"
        [backgroudColor]="datos.color" [docentes]="datos.teaching"></app-plan-de-estudio-posgrado>
    </div>
  </section>

  <section *ngIf="datos && datos.general_data_obj && datos.general_data_obj?.faqs && datos.general_data_obj?.faqs?.length >0">
    <div class="contenedores-seccion">
      <div class="titulo-propuesta">
        <h2 class="quicksand-bold title ">PREGUNTAS FRECUENTES</h2>

      </div>
      <div class="container-faqs row">
        <div class="fabs-divider">
          <div *ngFor="let faq of datos.general_data_obj?.faqs | slice:0:getHalfLength(); let i = index">
            <div *ngIf="faq.estado">
              <div class="div-preguntas" (click)="open(i)">
                <h2 class="quicksand-medium">{{faq.ask}}</h2>

                <img onerror="this.src='./assets/img/default.png'"
                  [src]="visibleFaqs[i] ? './assets/img/flecha-arriba-posgrado.png' : './assets/img/flecha-abajo-posgrado.png'"
                  class='icon pointer float-right inline' id="arrow" alt="">

              </div>

              <div *ngIf="visibleFaqs[i]">
                <div class="container-respuesta">
                  <span class="respuesta quicksand-medium">{{faq.answer}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fabs-divider">
          <div
            *ngFor="let faq of datos.general_data_obj?.faqs | slice:getHalfLength():datos.general_data_obj?.faqs.length; let j = index">
            <div *ngIf="faq.estado">
              <div class="div-preguntas" (click)="open(j + getHalfLength())">
                <h2 class="quicksand-medium">{{faq.ask}}</h2>

                <img onerror="this.src='./assets/img/default.png'"
                  [src]="visibleFaqs[j + getHalfLength()] ? './assets/img/flecha-arriba-posgrado.png' : './assets/img/flecha-abajo-posgrado.png'"
                  class='icon pointer float-right inline' id="arrow" alt="">

              </div>

              <div *ngIf="visibleFaqs[j + getHalfLength()]">
                <div class="container-respuesta">
                  <span class="respuesta quicksand-medium">{{faq.answer}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div *ngIf="!isDesktop" class="linea"></div>
    </div>
  </section>
  <section *ngIf="datos && datos.propuestaAcademicaRelacionada.length> 0">
    <div class="contenedores-seccion">
      <div class="titulo-propuesta">
        <h2 class="quicksand-bold title ">PROPUESTAS ACADÉMICAS RELACIONADAS</h2>
      </div>
      <div class="carreras-container">
        <ng-container
          *ngFor="let carrera of isDesktop ? datos.propuestaAcademicaRelacionada.slice(0,4) : datos.propuestaAcademicaRelacionada.slice(0, 1)">
          <app-cards-posgrados class="spaceInUp zoomIn" [carrera]="carrera" [posgrado]="true"></app-cards-posgrados>
        </ng-container>


        <div class="card-vacia  zoomIn">
          <a [href]="datos.link">
            <p class="texto-card quicksand-bold"> Conocé toda la oferta academica que tenemos para ofrecerte</p>
            <div>
              <img src='./assets/img/flecha-card-posgrado.png' alt="">
            </div>
          </a>

        </div>
      </div>
    </div>
  </section>
  <!-- <section *ngIf="datos">
  <div class="contenedores-seccion">
    <div class="div-condiciones ">
      <div class="divbtn-condiciones1">
        <a class="btn-condiciones nunito-medium zoomIn" href="https://uca.edu.ar/es/posgrado/terminos-y-condiciones"
          target="_blank">
          TÉRMINOS Y CONDICIONES
        </a>
      </div>

      <div class="divbtn-condiciones2">
        <a class="btn-condiciones nunito-medium  zoomIn" [href]="datos.regret" target="_blank">
          BOTON DE ARREPENTIMIENTO
        </a>
      </div>




    </div>
  </div>

</section> -->
</div>